module.exports = __webpack_public_path__ + "img/piebg.24153fa1.png";